import React from "react";
import CashMetricReport from "../components/CashMetricReport";

export default function DeclaredCashReportPage() {
  return (
    <CashMetricReport
      title="Declared Cash Report"
      endpoint="/advance-reports/declared-cash"
      exportEndpoint="/advance-reports/declared-cash/export"
      metricKey="declaredCash"
      metricLabel="Declared Cash"
      totalsKey="totalDeclaredCash"
      csvFilename="declared-cash-report.csv"
    />
  );
}
